// src/modules/core/_main.module/_common.module/base-classes.module/_logger.part/utils/_parts/trim-string.util.ts

export const MAX_STRING_LENGTH = 8000;

export function trimString(
  str: string,
  maxLen: number = MAX_STRING_LENGTH,
): string {
  if (str.length <= maxLen) {
    return str;
  }
  return str.slice(0, maxLen) + '... [TRUNCATED]';
}
